export { default } from './DefaultLocationsTableFooter';
